export const TOOL_CONFIRMATION_LABELS = {
  APPROVE: 'Approve',
  APPROVE_AND_ADD: ({ count }) => `Approve & add ${count}`,
  DECLINE: 'Decline',
  DECLINE_ALL: 'Decline all',
  CONDITIONS_INTRO: ({ count }) =>
    count === 1
      ? '1 condition will be added to the loan. Approve — or adjust it first.'
      : `${count} conditions will be added to the loan. Approve — or adjust any one first.`,
  REASON_PLACEHOLDER: 'Reason (optional)',
  REASON_SUBMIT: 'Confirm decline',
  REASON_CANCEL: 'Cancel',
  APPROVING: 'Approving…',
  REJECTING: 'Declining…',
  EXECUTED: 'Completed',
  FAILED: 'Failed',
  CANCELLED_DEFAULT: 'Cancelled by user',
  CANCELLED_WITH_REASON_PREFIX: 'Cancelled: ',
  TIMED_OUT: 'No response in 15 minutes; action cancelled.',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  UNKNOWN_TOOL_HEADLINE: 'Approve this action',
  OPEN_LOAN_SECTION_HEADLINE: 'Open a loan section',
  OPEN_LOAN_SECTION_DETAIL_PREFIX: 'Navigates to: ',
  HIGHLIGHT_FIELD_HEADLINE: 'Navigate to field',
  HIGHLIGHT_FIELD_DETAIL_PREFIX: 'Field: ',
  EDIT_FIELD_HEADLINE: 'Update a field',
  EDIT_FIELD_DETAIL_PREFIX: 'Field: ',
  SLA_GROUP_LABEL: 'SLA group',
  SLA_GROUP_PLACEHOLDER: 'Choose an SLA group',
  SLA_GROUP_PROMPT: 'Choose an SLA group for the conditions before approving.',
};

export const TOOL_RESULT_SUMMARY_LIMIT = 120;

export const TOOL_CONFIRMATION_FLOW = {
  BACKEND: 'backend',
  FRONTEND: 'frontend',
};
